/** @jsxImportSource @emotion/react */
import { SerializedStyles, css } from "@emotion/react";
import React from "react";
import { effects } from "./effects";
import { colors } from "./colors";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { StyledText } from "../assets/typography/typography";

const textWrapperStyle = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

const iconWrapper = css`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  min-height: 24px;
  width: 24px;
  height: 24px;
`;

const childrenWrapperStyle = css`
  width: 100%;
`;

type Props = {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
  additionalStyles?: SerializedStyles;
};

export const StyledInfoBox = ({
  title,
  subtitle,
  additionalStyles,
  children,
}: Props) => {
  const wrapperStyle = css`
    display: flex;
    align-items: start;
    flex-direction: row;
    padding: 16px;
    border-radius: 6px;
    ${!subtitle && "align-items: center;"}
    gap: 16px;
    width: 100%;
    box-shadow: ${effects.buttonPrimary};
    background-color: ${colors.whiteHover};
    ${additionalStyles}
  `;

  return (
    <div css={wrapperStyle}>
      <div css={iconWrapper}>
        <FontAwesomeIcon
          color={colors.textPrimary}
          icon={solid("info-circle")}
        />
      </div>
      <div css={textWrapperStyle}>
        <StyledText
          color={colors.textPrimary}
          className="bodyTextSemibold mb-0"
        >
          {title}
        </StyledText>
        {subtitle && (
          <StyledText
            color={colors.textSecondary}
            className="bodySubtextRegular mb-0"
          >
            {subtitle}
          </StyledText>
        )}
        {children && <div css={childrenWrapperStyle}>{children}</div>}
      </div>
    </div>
  );
};
